<template>
	<v-navigation-drawer
		app
		hide-overlay
		fixed
		stateless
		height="100vh"
		class="sidebar-border media-print"
		:style="`background-color:${$appColors.white}`"
		:mini-variant.sync="mini"
		width="200"
		v-model="drawer"
	>
		<v-toolbar flatd :style="`background-color:${$appColors.white}`">
			<v-list class="bars-align">
				<v-list-tile class="logo-company">
					<img
						:src="company.logoOpen"
						alt="logo compañia"
						class="logo-open"
					/>
					<img
						:src="company.logoClose"
						alt="logo compañia"
						class="logo-close"
					/>
				</v-list-tile>
				<v-list-tile-avatar class="avatar-image">
					<img
						:src="avatar"
						class="icon-avatar"
						@click="goToUser"
					/>
				</v-list-tile-avatar>
				<v-list-tile-content>
            		<v-list-tile-title class="avatar-name">{{fullName}}</v-list-tile-title>
					<v-list-tile-title class="avatar-position">{{user.position}}</v-list-tile-title>
          		</v-list-tile-content>
			</v-list>
		</v-toolbar>
		<v-list
			class="py-0 sidebar-bg mgt-1"
			:style="`background-color:${$appColors.sidebar}`"
		>
			<v-list-group
				v-for="item in items"
				:key="item.id"
				no-action
			>
				<v-list-tile
					v-if="item.resource.data.length === 0"
					slot="activator"
					:to="item.uri"
					color="secondary"
					:class="{ 'v-list__group__header--active' : item.name === $route.meta.title }"
					active-class="white--text">
					<div
						class="item-select"
						:style="`background-color:${$appColors.secondary} !important`"
					></div>
					<v-list-tile-content>
						<v-list-tile-title>{{ item.name }}</v-list-tile-title>
					</v-list-tile-content>
					<v-list-tile-action>
						<v-tooltip right>
							<img slot="activator" :src="item.pathIcon">
							<span>{{ item.name }}</span>
						</v-tooltip>
					</v-list-tile-action>
				</v-list-tile>
				<v-list-tile
					v-else
					slot="activator"
					class="padding-items"
					:class="{ 'v-list__group__header--active' : item.name === $route.meta.title }"
					color="white"
				>
					<div class="item-select"
						:style="`background-color:${$appColors.secondary} !important`"
					></div>
					<v-list-tile-action class="item-action-sidebar">
						<v-tooltip right>
							<img slot="activator" :src="item.pathIcon">
							<span>{{ item.name }}</span>
						</v-tooltip>
					</v-list-tile-action>
					<v-list-tile-content class="ml-2 body-2 bold">
						<v-list-tile-title>{{ item.name }}</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>
				<v-list-tile
					v-for="subItem in item.resource.data"
					:key="subItem.uri"
					:to="{ name: subItem.uri }"
					:class="{ 'item-sidebar-active' : $route.name === subItem.uri }"
					color="secondary"
					class="resources-items"
					active-class="white--text">
					<v-list-tile-action class="item-action-sidebar">
						<v-tooltip right>
							<img slot="activator" :src="subItem.iconUrl">
							<span>{{ subItem.name }}</span>
						</v-tooltip>
					</v-list-tile-action>
					<v-list-tile-content>
						<v-list-tile-title>{{ subItem.name }}</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>
			</v-list-group>
        </v-list>
	</v-navigation-drawer>
</template>

<script>
import helper from '@/shared/helper';
import { mapGetters, mapState } from 'vuex';

function created() {
	this.loadData();
}

function data() {
	return {
		company: {
			logoOpen: process.env.LOGO,
			logoClose: process.env.LOGO_SMALL,
		},
		drawer: true,
		items: [],
		mini: false,
		routeObject: {},
		user: {
			position: 'Gerente General',
		},
	};
}

async function loadData() {
	const params = {
		languages: 'es',
	};
	const headers = {
		Accept: 'application/vnd.apiacl.v2+json',
	};
	try {
		const response = await this.$httpAcl.get(`sidebar/${process.env.APP_CODE}`, { headers, params });
		this.items = response.data.data.map((item) => {
			this.setRouteManifest(item);
			const newItem = Object.assign({}, item);
			if (item.resource.data.length === 0) {
				if (item.uri === this.$route.path) {
					newItem.active = true;
				}
			} else {
				item.resource.data.forEach((src) => {
					if (src.uri === this.$route.path || `/${src.uri}` === this.$route.path) {
						newItem.active = true;
					}
				});
				item.resource.data.sort((a, b) => a.position - b.position);
			}
			return newItem;
		}).sort((a, b) => a.position - b.position);
		helper.setLocalData('sidebar', this.items);
		this.$emit('active-route', this.items);
		this.$store.dispatch('setSideBarRoutes', this.routeObject);
	} catch (err) {
		this.$store.showSnackBar({
			color: 'error',
			text: 'Error interno, recargue la página e intente de nuevo',
		});
	}
}

function setRouteManifest(route) {
	const self = this;
	route.resource.data.forEach((r) => {
		const { uri } = r;
		self.routeObject[uri] = uri;
	});
}

function toggle() {
	this.mini = this.toggle;
}

function mini(value) {
	this.$emit('toggle-sidebar', value);
}

function goToUser() {
	this.goTo('profile');
}

export default {
	name: 'app-sidebar',
	computed: {
		...mapGetters([
			'fullName',
		]),
		...mapState({
			avatar: state => state.user.urlImage,
		}),
	},
	created,
	data,
	methods: {
		loadData,
		goToUser,
		setRouteManifest,
	},
	props: {
		toggle: {
			type: Boolean,
			default: true,
		},
	},
	watch: {
		toggle,
		mini,
	},
};
</script>

<style lang="scss" scoped>
.list {
	&__tile__action {
		justify-content: flex-end;
	}
}

aside {

	@media (max-width: 768px) {
		display: none;
	}
}

.v-navigation-drawer {
	z-index: 200;

	&--mini-variant {
		.list__tile__action {
			justify-content: center;
		}
	}
}

.item-action-sidebar {
	.v-tooltip {
		max-height: 25px;

		img {
			filter: brightness(4) invert(3);
		}
	}
}

.logo-open {
	height: 34px;
	width: 137px;
}

.logo-close {
	width: 40px;
}

.bold {
	color: #545a54;
	font-weight: bold !important;
}

.mgt-1 {
	margin-top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/app-sidebar.vue